import(/* webpackMode: "eager" */ "/vercel/path0/src/app/pro-waitlist/page.tsx");
